<script>

import store from '../vuex/store';
import FavoritesService from '../services/favorites';

// components
import Icon from './icon';
export default {
  store,
  components: {
    Icon
  },

  data () {
    return {
      favorited: false,
    }
  },

  props: {
    resourceId: null,
    resourceType: null
  },

  computed: {
    favorites() {
      return this.$store.state.favorites.favorites;
    },

    loggedIn() {
      return this.$store.state.loggedIn;
    },
  },

  mounted() {
    const self = this;
    if (!!self.favorites) {
      let idsTypes = self.favorites.map( function(f) {
        return [f.node.favoriteable_id, f.node.favoriteable_type]
      });

      idsTypes.forEach( function(resource) {
        if (resource[0] === parseInt(self.resourceId) && resource[1] === self.resourceType) {
          self.favorited = true;
        }
      });
    }
  },

  methods: {
    addFavorite() {
      const self = this;
      FavoritesService.add(self.resourceId, self.resourceType).then(
        response => {
          this.$store.dispatch('favorites/refresh');
          self.favorited = true;
        }
      )
    },
    removeFavorite () {
      const self = this;
      FavoritesService.destroy(self.resourceId, self.resourceType).then(
        response => {
          this.$store.dispatch('favorites/refresh');
          self.favorited = false;
        }
      )
    }
  }
}
</script>

<template lang="html">
  <form v-if="!!loggedIn" class="FavoriteForm FavoriteForm--billboard" @submit.prevent>
    <button v-if="!favorited" class="Button Button--toggle Button--soft-black" type="submit" @click="addFavorite">
      <icon icon="plus"></icon>
      Favorite
    </button>
    <button v-if="favorited" class="Button Button--toggle Button--soft-black" type="submit" @click="removeFavorite">
      <icon icon="minus"></icon>
      Favorite
    </button>
  </form>
</template>



// WEBPACK FOOTER //
// add-favorite.vue?1bdc6bfe